import { FormDataModel } from '@/model/FormModel'

export const FromFieldData: FormDataModel[] = [
  {
    title: '基本信息',
    type: 1, // 常规表单
    labelClass: 'blue',
    labelName: '基',
    formList: [
      {
        componentType: 'el-select',
        componentName: '下拉选择',
        fieldKey: 'superId',
        fieldName: '父级部门',
        placeholder: '',
        value: 0,
        rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        option: [{
          id: 0,
          superName: '顶级'
        }],
        config: {
          collapseTags: false,
          isDisabled: true,
          multiple: false,
          clearable: false,
          selectType: 3 // 1本地2远程
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'name',
        fieldName: '部门名称',
        placeholder: '',
        value: '',
        rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true
        }
      }, {
        componentType: 'el-select',
        componentName: '下拉选择',
        fieldKey: 'nature',
        fieldName: '部门性质',
        placeholder: '',
        value: '',
        rules: [{ required: false, message: '请填写必填项', trigger: 'change' }],
        option: [],
        config: {
          collapseTags: false,
          isDisabled: false,
          multiple: false,
          clearable: true,
          filterable: true,
          url: 'DeptNature',
          selectType: 1// 1本地2远程
        }
      }
    ]
  }
]
